import { combineReducers } from 'redux';
import errorReducer from './errorReducer';
import authReducer from './authReducer';
import orgReducer from './orgReducer';
import clientReducer from './clientReducer';
import orderReducer from './orderReducer';
import orderDetailsReducer from './orderDetailsReducer';
import orderDetailsActiveReducer from './orderDetailsActiveReducer';
import userReducer from './userReducer';
import orgcurrentReducer from './orgcurrentReducer';

export default combineReducers({
    errors: errorReducer,
    auth: authReducer,
    organizations: orgReducer,
    orders: orderReducer,
    orderdetails:  orderDetailsReducer,
    orderdetailsactiveid:  orderDetailsActiveReducer,
    clients: clientReducer,
    orgcurrent: orgcurrentReducer,
    users: userReducer
});
